export const S3_URL = import.meta.env.VITE_S3_URL ?? '';
export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL ?? '';
export const REDIRECT_URL = import.meta.env.VITE_API_URL ?? '';
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL ?? '';
export const S3_SMALL_THUMB = import.meta.env.VITE_THUMB_SMALL ?? '';
export const S3_LARGE_THUMB = import.meta.env.VITE_THUMB_LARGE ?? '';
export const APP_GG_APP_ID = import.meta.env.VITE_APP_GG_APP_ID ?? '';
export const APP_GG__SECRET_APP_ID = import.meta.env.VITE_APP_GG_SECRET_APP_ID ?? '';
export const APP_AMAZON_APP_ID = import.meta.env.VITE_APP_AMAZON_APP_ID ?? '';
export const APP_INSTAGRAM_APP_ID = import.meta.env.VITE_APP_INSTAGRAM_APP_ID ?? '';
export const APP_INSTAGRAM_APP_SECRET = import.meta.env.VITE_APP_INSTAGRAM_APP_SECRET ?? '';
export const APP_MICROSOFT_APP_ID = import.meta.env.VITE_APP_MICROSOFT_APP_ID ?? '';
export const APP_LINKEDIN_APP_SECRET = import.meta.env.VITE_APP_LINKEDIN_APP_SECRET ?? '';
export const APP_LINKEDIN_APP_ID = import.meta.env.VITE_APP_LINKEDIN_APP_ID ?? '';
export const APP_GITHUB_APP_ID = import.meta.env.VITE_APP_GITHUB_APP_ID ?? '';
export const APP_GITHUB_APP_SECRET = import.meta.env.VITE_APP_GITHUB_APP_SECRET ?? '';
export const APP_TWITTER_APP_ID = import.meta.env.VITE_APP_TWITTER_APP_ID ?? '';
export const APP_TWITTER_V2_APP_KEY = import.meta.env.VITE_APP_TWITTER_V2_APP_KEY ?? '';
export const APP_TWITTER_V2_APP_SECRET = import.meta.env.VITE_APP_TWITTER_V2_APP_SECRET ?? '';
export const APP_APPLE_ID = import.meta.env.VITE_APP_APPLE_ID ?? '';
export const APP_TIKTOK_CLIENT_KEY = import.meta.env.VITE_APP_TIKTOK_CLIENT_KEY ?? '';
export const APP_FACEBOOK_APP_ID = import.meta.env.VITE_FACEBOOK_APP_ID ?? '';
export const BLOG_URL = import.meta.env.VITE_BLOG_URL ?? '';
export const ZEGOCLOUD_APP_ID = import.meta.env.VITE_ZEGOCLOUD_APP_ID ?? '';
export const ZEGOCLOUD_SERVERSECRET = import.meta.env.VITE_ZEGOCLOUD_SERVERSECRET ?? '';
export const ZEGOCLOUD_APPSIGN = import.meta.env.VITE_ZEGOCLOUD_APPSIGN ?? '';
export const ZEGOCLOUD_RESOURCESID = import.meta.env.VITE_ZEGOCLOUD_RESOURCESID ?? '';
export const PRODUCTION_MODE: boolean = import.meta.env.VITE_PRODUCTION_MODE === 'true';
export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'Jobstas';

export const INCOMING_RING = import.meta.env.VITE_ZEGOCLOUD_INCOMING_RING ?? '';
export const OUTGOING_RING = import.meta.env.VITE_ZEGOCLOUD_OUTGOING_RING ?? '';

export const FACEBOOK_URL = import.meta.env.VITE_FACEBOOK_URL;
export const TWITTER_URL = import.meta.env.VITE_TWITTER_URL;
export const LINKEDIN_URL = import.meta.env.VITE_LINKEDIN_URL;
export const INSTAGRAM_URL = import.meta.env.VITE_INSTAGRAM_URL;
export const YOUTUBE_URL = import.meta.env.VITE_YOUTUBE_URL;
export const TIKTOK_URL = import.meta.env.VITE_TIKTOK_URL;
export const LINKED_IN_CLIENT_ID = import.meta.env.VITE_APP_LINKEDIN_CLIENT_ID;
export const LINKED_IN_CLIENT_SECRET = import.meta.env.VITE_APP_LINKEDIN_CLIENT_SECRET;
export const LINKED_IN_REDIRECT_URL = import.meta.env.VITE_LINKEDIN_REDIRECT_URL;
export const APP_IP_API = import.meta.env.VITE_APP_IP_API;

export const USER_TYPES = {
	SEEKER: 'seeker',
	COMPANY: 'company',
};

export const dataLimits = {
	homePopularJobs: 6,
	myMatchesJobs: 9,
	popularJobs: 9,
	favouriteJobs: 9,
	appliedJobs: 9,
	filterJobs: 8,
	postedJobs: 4,
	postedJobsListing: 6,
	applicantsListing: 10,
	inActiveListing: 10,
	postLikedModal: 50,
	feedsListing: 10,
	feedComments: 5,
	feedCommentReply: 10,
	storyViewers: 18,
	sharePostModal: 50,
	limits: 20,
	membersResults: 20,
	chatMessages: 50,
	membersResultsPeople: 12,
	blogs: 30,
	advertisement: 9,
	allActivity: 5,
	recentActivity: 3,
	paymentHistory: 10,
};

export const commonSortingOptions = (translate: any) => {
	return [
		{
			label: translate('PlaceHolder.newest'),
			orderBy: 'createdAt',
			order: 'DESC',
			value: 'newest',
		},
		{
			label: translate('PlaceHolder.oldest'),
			orderBy: 'createdAt',
			order: 'ASC',
			value: 'oldest',
		},
	];
};

export const contactUsDetails = {
	email: 'info@jobstas.com',
	phone: '(480) 555-0103',
	address:
		'Jobstas Recruiting GmbH<br />c/o Alkan Kama<br />Joachim-Ringelnatz-Weg 6a<br />14532 Stahnsdorf, Germany',
};

export const jobStatus = [
	{ value: 'applied', label: 'Applied' },
	{ value: 'screened', label: 'Shortlisted' },
	{ value: 'interview', label: 'Interviewed' },
	{ value: 'offered', label: 'Offered' },
];

export const mentionTagsStyles = {
	'&multiLine': {
		control: {},
		input: {
			backgroundColor: 'transparent',
			border: '0',
			padding: '0',
		},
	},
	'&singleLine': {
		display: 'inline-block',
		width: 180,
		highlighter: {
			padding: 1,
			border: '2px inset transparent',
		},
		input: {
			padding: 0,
			border: '2px inset',
			color: '#1b1b1b',
		},
	},
	suggestions: {
		borderRadius: '12px',
		boxShadow: '0px 4px 15px 0px rgba(206, 203, 210, 0.26)',
		zIndex: '999',
		list: {
			backgroundColor: 'white',
			borderRadius: '12px',
			fontSize: 14,
			minWidth: '150px',
			maxHeight: '228px',
			overflow: 'auto',
		},
		item: {
			padding: '8px 15px',
			color: '#1b1b1b',
			borderBottom: '1px solid #f5f4fa',
			'&focused': {
				backgroundColor: '#1488ff',
				color: '#fff',
			},
		},
	},
};

export const SLUGS: any = {
	skills: 'skills',
	tools: 'tools',
	industries: 'industries',
	language: 'languages',
	social: 'socialMedia',
};

export const COLORS_STYLING = {
	primary: '#9727F5',
};

export const TEXTAREA_TEXT_LIMIT = 500;

export const postImageSetting: any = {
	1: [
		{
			width: 2,
			height: 2.5,
		},
	],
	2: [
		{
			width: 2,
			height: 2.5,
		},
		{
			width: 2,
			height: 2.25,
		},
	],
	3: [
		{
			width: 2,
			height: 2.5,
		},
		{
			width: 2,
			height: 1.25,
		},
		{
			width: 2,
			height: 1.25,
		},
	],
	4: [
		{
			width: 2,
			height: 1.25,
		},
		{
			width: 2,
			height: 1.25,
		},
		{
			width: 2,
			height: 1.25,
		},
		{
			width: 2,
			height: 1.25,
		},
	],
};
export const myConnectionUrl = ['/seeker/my-connections'];
export const hashtagListUrl = ['/seeker/members-result', '/company/members-result'];

export const onlySpecialCharsNotAllowRegex = /^(?=.*[a-zA-Z0-9])[\w\W]*$/;

export const formatDateForMeeting = (date: any) => {
	const day = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
	const year = date.getFullYear();
	return `${month}/${day}/${year}`;
};

export const statusForMeeting = ['pending', 'completed', 'cancelled'];
export const minDate = '1900-01-01';

export const convertSeconds = (seconds: number) => {
	const timeUnits = [
		{ unit: 'hour', value: Math.floor(seconds / (60 * 60)) },
		{ unit: 'min', value: Math.floor((seconds % (60 * 60)) / 60) },
		{ unit: 'sec', value: seconds % 60 },
	];

	return timeUnits
		.filter(({ value }) => value > 0) // Filter out units with value 0
		.map(({ unit, value }) => `${value} ${unit}${value !== 1 ? 's' : ''}`) // Add 's' for plural units
		.join(', ');
};

export const notificationTypes = {
	tagOnSocialPost: '/feed-detail',
	connectionRequest: '/seeker/my-connections?activeTab=request&value=',
};

export const ALLOWEDVIDEOFORMATS = ['video/mp4', 'video/quicktime'];

export const LANGUAGE_MAPPING = {
	en: ['US', 'GB', 'AU', 'CA', 'NZ', 'IE', 'SG', 'ZA'], // English-speaking countries
	hi: ['IN'], // Hindi for India
	tr: ['TR'], // Turkish for Turkey
	de: ['DE', 'AT', 'CH'], // German-speaking countries
	es: [
		'ES',
		'MX',
		'AR',
		'CO',
		'CL',
		'PE',
		'VE',
		'CR',
		'DO',
		'EC',
		'GT',
		'HN',
		'NI',
		'PA',
		'PY',
		'SV',
		'UY',
	], // Spanish-speaking countries
};

export const GENDER_LIST = ['man', 'woman', 'diverse'];
export const APP_STORE = import.meta.env.VITE_APP_STORE ?? '';
export const PLAY_STORE = import.meta.env.VITE_PLAY_STORE ?? '';

export const JOOBLE_JOB_ROLES = [
	'Software Development',
	'Healthcare',
	'Production',
	'Retail',
	'Logistics',
	'Education',
	'Science',
	'Finance',
	'Technology',
	'Hospitality',
	'Social Work',
	'Management',
	'Construction',
	'Sports',
	'Marketing',
	'Arts',
	'Business',
	'Communication',
];
